import { render } from "./ChipRenderer.vue?vue&type=template&id=6892b787&scoped=true"
import script from "./ChipRenderer.vue?vue&type=script&lang=ts"
export * from "./ChipRenderer.vue?vue&type=script&lang=ts"

import "./ChipRenderer.vue?vue&type=style&index=0&id=6892b787&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6892b787"

export default script